import { createSlice, isAnyOf, PayloadAction } from '@reduxjs/toolkit';

import authApi from 'modules/auth/service';
import dealersApi from 'modules/dealers/service';
import selfServicesApi from 'modules/selfServices/service';
import type InitialState from './types/InitialState';
import type { ContextResponse } from './types/ContextResponse';
import type { InitialState as LoginResponse } from '../auth/types/InitialState';
import { mergeContextWithToken } from './utils';

const dealersSlice = createSlice({
  name: 'dealers',
  initialState: {
    status: 200,
    context: null,
  } as InitialState,
  reducers: {
    overrideContext(state, { payload }: PayloadAction<Partial<ContextResponse>>) {
      state.context = { ...state.context, ...payload };
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      dealersApi.endpoints.getContext.matchFulfilled,
      (state, action: PayloadAction<ContextResponse>) => ({
        ...state,
        context: action.payload,
        status: 200,
      }),
    );
    builder.addMatcher(authApi.endpoints.getMFAConnection.matchFulfilled, (state, action) => {
      const {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        connectionId, email, phoneNumber, selfServiceId, type, ...rest
      } = action.payload;

      return {
        ...state,
        context: {
          ...state.context,
          ...rest,
        },
        status: 200,
      };
    });
    builder.addMatcher(isAnyOf(authApi.endpoints.login.matchFulfilled, authApi.endpoints.sendQrCode.matchFulfilled),
      (state, action: PayloadAction<LoginResponse>) => {
        const { token } = action.payload;
        return {
          ...state,
          context: mergeContextWithToken(state.context, token),
          status: 200,
        } as InitialState;
      });
    builder.addMatcher(
      selfServicesApi.endpoints.getPaymentMethods.matchFulfilled,
      (state, action) => ({
        ...state,
        context: {
          ...state.context,
          paymentMethods: action.payload,
        },
      }),
    );
    builder.addMatcher(
      dealersApi.endpoints.getContext.matchRejected,
      (state, action) => ({
        ...state,
        status: typeof action.payload?.status === 'number' ? action.payload.status : 404,
      }),
    );
  },
});

export default dealersSlice;
